
import {Component, Mixins, Prop} from 'vue-property-decorator';
import SimpleInputMixin from "@/mixins/SimpleInputMixin.vue";

@Component({})
export default class IndirilecekEvrakTuruPicker extends Mixins(SimpleInputMixin) {
  @Prop() hideDetails!: string | boolean;
  @Prop() rules!: string;
  @Prop() dense!: string | boolean;

  get isHideDetails() {
    return this.hideDetails || this.hideDetails === "";
  }

  items = [
    "89/1 Haciz İhbarnamesi Cevabı",
    "Adres Araştırması Talebi",
    "Adres Sorusturmasi",
    "Araç Mahrumiyet Raporu",
    "Avukat Portal Genel Talebi",
    "Avukat Portal Haciz Talebi",
    "Avukat Portal Tebligat Talebi",
    "Bankadan Gelen Cevap Yazısı",
    "Belediye İmar Durumu",
    "Bilirkişi Ek Raporu",
    "Bilirkişi Raporu",
    "Bilirkişi Teslim Tutanağı",
    "Bilirkişi Teslim Tutanağı (İmzalı)",
    "Borca İtiraz Talebi",
    "Borçlu Eklenmesi Talebi",
    "Cezaevi Harcı Makbuzu",
    "Dosyaya Eklenen Son ... Evrak",
    "Emniyet Haciz Evrak",
    "Genel Haciz Talebi",
    "Genel Satış Evrakı",
    "Haciz Karar Yazısı",
    "Haciz Tutanağı",
    "İcra Daireleri Banka Haciz Yazısı",
    "İcra Daireleri Haciz Tebliğ Yazısı",
    "İcra Dairesi Genel Yazı",
    "Kapalı E-Tebliğ Mazbatası",
    "Kapalı Tebligat",
    "Maaş Bilgisi Evrakı",
    "Mal Beyanı Bildirim",
    "Masraf Makbuzu",
    "Ödeme İcra Emri",
    "PTT Tebligat Sorgulaması",
    "Reddiyat Banka Ödeme Dekontu",
    "Reddiyat Beyanı",
    "Reddiyat makbuzu",
    "Satış Talebi",
    "SGK Haciz Ekleme Raporu",
    "SGK Haciz İcra Bilgileri",
    "Tahsil Harcı Makbuzu(Sayman Mutemet Alındısı)",
    "Tahsilat makbuzu",
    "Takbis Mahrumiyet Ekleme Cevap Raporu",
    "Takbis Takyidat Raporu",
    "Takibin Dayanagi Belge",
    "Takip Talebi",
    "Takpas Mahrumiyet Ekleme Yazısı",
    "Takyidat Bilgisi Sorma Talebi",
    "Taşıt Mahrumiyet Ekleme/Kaldırma Evrakı",
    "Tebliğ Mazbatası",
    "Tensip zaptı",
    "Vekalet Pulu Makbuzu",
    "Vekaletname",
    "Yetkisizlikle Kapatılan Dosyanın Gönderilmesi"
  ];
}
